export const CARE_PROFILE_ROUTE = "/care-profile";
